<template>
    <div id="preview-main">
        <div class="report">
            <!-- 封面 -->
            <div class="report-cover">
                <!-- 头 -->
                <Row>
                    <Col>
                        <img :src="ball" style="height: 600px;float: right;">
                    </Col>
                </Row>
                <!-- 中间 -->
                <div class="report-cover-main">
                    <div></div>
                    <div><span name="companyName">{{companyName}}</span></div>
                    <div><span name="year">{{year}}</span>年<span name="month">{{month}}</span>月AWS运维报告</div>
                    <div>ver 3.0</div>
                </div>
                <!-- 尾部 -->
                <div class="report-cover-bottom">
                    <img :src="foot">
                </div>
            </div>
        </div>

        <div class="report">
            <!-- 目录 -->
            <div class="report-contents">
                <!-- 头 -->
                <Row>
                    <Col span="24">
                        <img :src="contentsPicture" style="width: 100%;">
                    </Col>
                </Row>
                <!-- 中间 -->
                <Row>
                    <Col span="24">
                        <div class="report-contents-right">
                            <!--标题 -->
                            <div class="report-contents-title" style="margin-top: 69px;">
                                <span class="report-contents-title-left">01</span>
                                <span class="report-contents-title-right">
                                    <div>工作总结</div>
                                    <div>1.1事件分析</div>
                                    <div>
                                        <div>1.1.1事件处理</div>
                                        <div>1.1.2月度告警分析</div>
                                        <div>1.1.3事件SLA分析</div>
                                    </div>
                                    <div>1.2月度账务分析</div>
                                </span>
                            </div>
                            <div class="report-contents-title">
                                <span class="report-contents-title-left">02</span>
                                <span class="report-contents-title-right">
                                    <div>实例优化建议</div>
                                    <div>2.1 EC2优化建议</div>
                                    <div id="secondColumn">2.2 RDS优化建议</div>
                                    <div>2.3 实例花费节省预览</div>
                                    <div id="thirdColumn">
                                        <div>2.3.1 降级前后花费对比</div>
                                        <div>2.3.2 预留实例推荐花费对比</div>
                                    </div>
                                </span>
                            </div>
                            <div class="report-contents-title" style="min-height: 54px;">
                                <span class="report-contents-title-left">03</span>
                                <span class="report-contents-title-right">
                                    <div>其他优化建议</div>
                                </span>
                            </div>
                            <div class="report-contents-title" style="min-height: 54px;">
                                <span class="report-contents-title-left">04</span>
                                <span class="report-contents-title-right">
                                    <div>RI匹配情况</div>
                                </span>
                            </div>
                            <div class="report-contents-title" style="min-height: 80px;">
                                <span class="report-contents-title-left">05</span>
                                <span class="report-contents-title-right">
                                    <div>运维工作</div>
                                    <div>5.1本月运维事件</div>
                                    <div id="contents-second">5.2上月待处理事件</div>
                                </span>
                            </div>
                            <div class="report-contents-title">
                                <span class="report-contents-title-left">06</span>
                                <span class="report-contents-title-right">
                                    <div>重大事件</div>
                                </span>
                            </div>
                        </div>
                    </Col>
                </Row>
                <!-- 尾 -->
                 <Row>
                    <Col>
                        <img :src="foot" style="height: 100px;width: 100%;">
                    </Col>
                </Row>
            </div>
        </div>

        <div class="report">
            <!-- 工作总结 -->
            <div class="summary">
                <div class="summary-bigTitle">1. 工作总结</div>
                <!-- 1.1事件分析 -->
                <div class="summary-secondTitle">1.1 事件分析</div>
                <!-- 1.1.1 事件处理 -->
                <div class="summary-thirdTitle">1.1.1 事件处理</div>

                <!-- 事件总览 -->
                <div class="summary-event" id="eventOverview"></div>
                <div class="summary-first"><span name="month">{{month}}</span>月份在Case数量为<span name="amount">{{amount}}</span>个，相比<span
                     name="compareMonth">{{compareMonth}}</span>月份<span name="increasedReduction">{{increasedReduction}}</span><span name="cmAmount">{{cmAmount}}</span>个。在收到case请求以后，值班工程师均在不同的事件响应级别内进行了响应。</div>
                <div class="summary-second"><span name="month">{{month}}</span>月份事件处理的详细信息请查看运维工作列表。</div>
                <!-- 1.1.2月度告警分析 -->
                <div class="summary-thirdTitle">1.1.2 月度告警分析</div>
                <div class="other-first">从下图可以看到<span name="month">{{month}}</span>月份总共收到<span name="reviews">{{reviews}}</span>条告警信息，主要来自于EC2实例流量输出的告警，相关工程师已经通知并协助处理了告警。</div>
                <div id="warning"></div>
                <!-- 1.1.3事件SLA分析 -->
                <div class="summary-thirdTitle">1.1.3 事件SLA分析</div>
                <div class="summary-third">通过对上月所有事件的分析，上月份事件的平均响应时间为<span name="time">{{responseTimeAvg}}</span>分钟，此数据基于御云者的e-ITILining系统。</div>
                <div class="summary-time">
                    <div class="summary-time-title">平均响应时间</div>
                    <div name="time">{{responseTimeAvg}}Min</div>
                </div>
                <div class="summary-third">通过对上月所有事件的分析，上月份事件的平均解决时间为<span name="time">{{solutionTimeAvg}}</span>分钟，此数据基于御云者的e-ITILining系统。</div>
                  <div class="summary-time">
                    <div class="summary-time-title">平均解决时间</div>
                    <div name="time">{{solutionTimeAvg}}Min</div>
                  </div>
            </div>
        </div>

        <div class="report">
            <div class="accounting">
                <!-- 1.2月度账务分析 -->
                <div class="accounting-secondTitle" style="margin-top: 40px;">1.2 月度账务分析</div>
                <div class="accounting-first">从下图可以看到总体费用（这里的金额单位都是人民币）相对<span name="compareMonth">{{billRelativeMonthStr}}</span>月份账单<span
                     name="fallingUp">{{billCompareResult}}</span><span name="percentage">{{billCompareResultRatio}}</span>，原因<span name="accountReason">{{billAnalysis}}</span>。此图来自御云者e-Billing。</div>
                <div id="annualMonthlyExpenses"></div>
                <div class="accounting-second" style="margin-top: 60px;">继续对<span name="month">{{month}}</span>月份用量进行细化，分摊到不同的服务上去，可以看到用量仍然主要集中在<span name="mainFocus">{{mainFocusService}}</span>这几个服务上，每个服务所占的比例如下：</div>
                <div style="width:100%;font-size: 13px;text-align: center;color: #424242;font-weight: 600;">Top5服务花费</div>
                <div id="totalEvents" style="width: 210mm;height:300px;"></div>
                <div class="accounting-third">此图来自御云者e-Billing，旨在告知每项服务在AWS账户花费中所占的比例，数据为经过四舍五入的。</div>
            </div>
        </div>

        <div class="report">
            <div class="example">
                <!-- 实例优化建议 -->
                <div class="example-bigTitle">2. 实例优化建议</div>
                <!-- 2.1 EC2优化建议 -->
                <div class="accounting-secondTitle">2.1 EC2优化建议</div>
                <!-- 6月份EC2实例运行状况预览及优化建议 -->
                <div class="example-EC2">
                    <!-- 标题 -->
                    <div class="example-EC2-title"><span name="month">{{month}}</span>月份EC2实例运行状况预览及优化建议</div>
                    <table id="table-first" cellpadding="0" cellspacing="0">
                        <thead>
                            <tr>
                                <th>实例名称</th>
                                <th>实例类型</th>
                                <th>CPU使用率(%)</th>
                                <th>内存使用率(%)</th>
                                <th>优化建议</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item,i) in newEc2Suggest">
                                <td>{{item.resourceName}}</td>
                                <td>{{item.resourceType}}</td>
                                <td>{{item.cpuUtilization}}%</td>
                                <td>{{item.memoryUtilization}}%</td>
                                <td>{{item.optimizeSuggestion}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <!-- 优化建议 -->
                <div class="example-suggestion">
                    <div><span style="font-weight: 600;">EC2优化建议：</span><span name="EC2suggestions">{{ec2OptimizeSuggestion}}</span></div>
                </div>

                <!-- 6月份RDS实例运行状况预览及优化建议 -->
                <!-- 2.2 RDS优化建议 -->
                <div class="accounting-secondTitle">2.2 RDS优化建议</div>
                <div class="example-EC2">
                    <!-- 标题 -->
                    <div class="example-EC2-title"><span name="month">{{month}}</span>月份RDS实例运行状况预览及优化建议</div>
                    <table id="table-second" cellpadding="0" cellspacing="0">
                        <thead>
                            <tr>
                                <th>数据库名称</th>
                                <th>数据库实例类型</th>
                                <th>CPU使用率(%)</th>
                                <th>剩余内存(MB)</th>
                                <th>剩余磁盘(GB)</th>
                                <th>优化建议</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item,i) in newRdsSuggest">
                                <td>{{item.resourceName}}</td>
                                <td>{{item.resourceType}}</td>
                                <td>{{item.cpuUtilization}}%</td>
                                <td>{{item.freememory}}MB</td>
                                <td>{{item.freeDisk}}GB</td>
                                <td>{{item.optimizeSuggestion}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <!-- 优化建议 -->
                <div class="example-suggestion">
                    <div><span style="font-weight: 600;">RDS优化建议：</span><span name="RDSsuggestions">{{rdsOptimizeSuggestion}}</span></div>
                </div>

                <!-- 2.3 实例花费节省预览 -->
                <div class="accounting-secondTitle">2.3 实例花费节省预览</div>
                <div class="example-first">如果基于以上的优化建议（实例降级）进行调整，可以在很大程度上节省贵公司的账务花费，优化之后年度总共可以节省花费<span name="saveMoney">{{saveMoney}}</span>，详细如下：</div>

                <!-- 2.3.1 降级前后花费对比 -->
                <div style="font-size:15px;font-weight: 600;">2.3.1 降级前后花费对比</div>
                <!-- 实例（EC2和RDS）降级前后花费对比 -->
                <div class="example-EC2">
                    <!-- 标题 -->
                    <div class="example-EC2-title">实例（EC2和RDS）降级前后花费对比</div>
                    <table id="table-third" cellpadding="0" cellspacing="0">
                        <thead>
                            <tr>
                                <th>实例名称</th>
                                <th>优化类型</th>
                                <th>实例调整前</th>
                                <th>实例调整后</th>
                                <th>调整前单价</th>
                                <th>调整后单价</th>
                                <th>可节省花费</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item,i) in instanceRelegationCost">
                                <td>{{item.resourceName}}</td>
                                <td>{{item.optimizeType}}</td>
                                <td>{{item.resourceType}}</td>
                                <td>{{item.optimizeResourceType}}</td>
                                <td>{{item.unitPriceBefore}}</td>
                                <td>{{item.unitPriceAfter}}</td>
                                <td>{{item.saveCost}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <!-- 2.3.2 预留实例推荐花费对比 -->
                <div style="font-size:15px;font-weight: 600;">2.3.2 预留实例推荐花费对比</div>
                <!-- 实例（EC2和RDS）购买预留实例前后花费对比 -->
                <div class="example-EC2">
                    <!-- 标题 -->
                    <div class="example-EC2-title">实例（EC2和RDS）购买预留实例前后花费对比</div>
                    <table id="table-fourth" cellpadding="0" cellspacing="0">
                        <thead>
                            <tr>
                                <th v-show="costComparison">账号ID</th>
                                <th v-show="costComparison">账号名称</th>
                                <th v-show="isAccountGroupName">账户组名称</th>
                                <th>租赁类型</th>
                                <th>实例系统</th>
                                <th>实例类型</th>
                                <th>推荐购买RI</th>
                                <th>按需年度花费</th>
                                <th>无前期RI年度花费</th>
                                <th>部分前期RI年度花费</th>
                                <th>全部前期年度花费</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item,i) in riCost">
                                <td v-show="costComparison">{{item.accountIdString}}</td>
                                <td v-show="costComparison">{{item.accountName}}</td>
                                <td v-show="isAccountGroupName">{{item.accountGroupName}}</td>
                                <td>{{item.instanceTenancy}}</td>
                                <td>{{item.productDescription}}</td>
                                <td>{{item.instanceType}}</td>
                                <td>{{item.unmatchCount}}</td>
                                <td>{{item.onDemandCost}}</td>
                                <td>{{item.noUpfrontCost}}</td>
                                <td>{{item.partUpfrontCost}}</td>
                                <td>{{item.allUpfrontCost}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <div class="report">
            <div class="other">
                <!-- 3 其他优化建议 -->
                <div class="example-bigTitle">3. 其他优化建议</div>
                <div id="result"></div>

                <!-- 4 RI匹配情况 -->
                <div class="example-bigTitle">4. RI匹配情况</div>
                <div class="other-first">贵公司账户购买了<span id="totalRINumber">{{console}}</span>台预留实例，经过后台检测，目前全部匹配，详细如下：</div>

                <div class="example-EC2">
                    <table id="table-fifth" cellpadding="0" cellspacing="0">
                        <thead>
                            <tr>
                                <th v-show="reservedInstance">账号ID</th>
                                <th v-show="reservedInstance">账号名称</th>
                                <th v-show="isReservedInstance">账户组名称</th>
                                <th>租赁类型</th>
                                <th>实例系统</th>
                                <th>实例类型</th>
                                <th>总共购买RI(单位:台)</th>
                                <th>未匹配RI(单位:台)</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item,i) in riMatching">
                                <td v-show="reservedInstance">{{item.accountIdString}}</td>
                                <td v-show="reservedInstance">{{item.accountName}}</td>
                                <td v-show="isReservedInstance">{{item.accountGroupName}}</td>
                                <td>{{item.instanceTenancy}}</td>
                                <td>{{item.productDescription}}</td>
                                <td>{{item.instanceType}}</td>
                                <td>{{item.instanceCount}}</td>
                                <td>{{item.unmatchCount}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="report">
            <div class="important">
                <!-- 5 运维工作 -->
                <div class="important-bigTitle">5. 运维工作</div>
                <!-- 5.1 本月运维事件 -->
                <div class="important-secondTitle">5.1 本月运维事件</div>
                <div class="operationalEvent">
                    <table id="table-sixth" cellpadding="0" cellspacing="0">
                        <thead>
                            <tr>
                                <th>时间</th>
                                <th>级别</th>
                                <th>事件描述</th>
                                <th>事件进度</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item,i) in newOperationEvents">
                                <td>{{item.ticketTime}}</td>
                                <td>{{item.priorityId}}</td>
                                <td>{{item.ticketDescribe}}</td>
                                <td>{{item.ticketProgress}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="operationalEvent-first">详细P1/P2/P3/P4 如何划分，见 备注一</div>

                <!-- 5.2 上月待处理事件 -->
                <div class="important-secondTitle">5.2 上月待处理事件</div>
                <div class="operationalEvent-first">根据上月度运维报告，贵公司还有部分优化事件待处理，如下：</div>
                <div class="operationalEvent">
                    <table id="table-seventh" cellpadding="0" cellspacing="0">
                        <thead>
                            <tr>
                                <th>待优化事件</th>
                                <th>所属类型</th>
                                <th>问题原因</th>
                                <th>事件进度</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item,i) in newPendingEvents">
                                <td>{{item.ticketDescribe}}</td>
                                <td>{{item.ticketCategory}}</td>
                                <td>{{item.ticketReasons}}</td>
                                <td>{{item.ticketProgress}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="report">
            <div class="majorEvent">
                <!-- 6 重大事件 -->
                <div class="majorEvent-bigTitle">6. 重大事件</div>
                <div class="majorEvent-main" v-for="item in reportEventList">
                    <div class="majorEvent-title">主题: {{item.eventTitle}}</div>
                    <div class="majorEvent-second">
                        <div>问题描述:</div>
                        <div>{{item.eventDescribe}}</div>
                    </div>
                    <div class="majorEvent-second">
                        <div>事件进展:</div>
                        <div>{{item.eventProgress}}</div>
                    </div>
                    <div class="majorEvent-second">
                        <div>事件结果:</div>
                        <div>{{item.eventResult}}</div>
                    </div>
                </div>
                <!-- 备注一： -->
                <div class="operationalEvent-first" style="font-weight: 600;">备注一：</div>
                <div class="operationalEvent-first">事件优先级分级政策如下：</div>
                <div class="operationalEvent">
                    <table id="table-eighth" cellpadding="0" cellspacing="0">
                        <thead>
                            <tr>
                                <th>要求</th>
                                <th>说明</th>
                                <th>服务指标</th>
                                <th>备注</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item,i) in remark">
                                <td>{{item.claim}}</td>
                                <td>{{item.explanation}}</td>
                                <td>{{item.serviceIndicators}}</td>
                                <td>{{item.remarks}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    var previewVue = {}
    export default {
        name: 'Preview',
        props:['previewEditOldForm'],
        data(){
            return{
                reportEventList:[],
                newOperationEvents:[],
                newPendingEvents:[],
                newEc2Suggest:[],
                newRdsSuggest:[],
                reservedInstance:false,
                isReservedInstance:false,
                isAccountGroupName:false,
                costComparison:false,
                console:0,
                saveMoney:12,
                ec2OptimizeSuggestion:'',
                rdsOptimizeSuggestion:'',
                mainFocusService:'',
                billAnalysis:'',
                billRelativeMonthStr:'',
                billCompareResult:'',
                billCompareResultRatio:'',
                responseTimeAvg:0,
                solutionTimeAvg:0,
                reviews:'',
                amount:'',
                compareMonth:'',
                increasedReduction:'',
                cmAmount:'',
                year:'',
                month:'',
                companyName:'',//反参
                accountIdList:[],
                reportId:0,
                companyId:0,
                reportDate:'',  //初始化传参
                serviceNameList:[], //Top5服务花费
                top5ServiceCosts:[],
                totalEventsChart:'',
                allServiceTotalCost:'',
                annualMonthlyExpenditure:[], //年度每月花费
                xaxisData:[],
                chartAnnualMonthlyExpenses:'',
                xaxisAlerts:[], //警报分析
                alertAmounts:[],
                chartWarning:'',
                xaxisTicket:[], //事件总览
                p1Amounts:[],
                p2Amounts:[],
                p3Amounts:[],
                chartEventOverview:'', // echarts实例
                ball:require('../../../../../static/images/1.png'),
                foot:require('../../../../../static/images/2.png'),
                contentsPicture:require('../../../../../static/images/contentsPicture.png'), //封面图片
                ec2Suggest:[], //EC2优化建议
                rdsSuggest:[], //RDS优化建议
                instanceRelegationCost:[], //实例（EC2和RDS）降级前后花费对比
                riCost:[], //实例（EC2和RDS）购买预留实例前后花费对比
                riMatching:[], //RI匹配情况
                operationEvents:[], //本月运维事件
                pendingEvents:[], //上月待处理事件
                remark:[{
                    claim:'一级事件（P1级事件）',
                    explanation:'系统的事件紧急程度高或影响程度大的事件',
                    serviceIndicators:'15分钟内响应',
                    remarks:'如:服务器宕机,网络事件导致服务不可用等'
                },
                {
                    claim:'二级事件（P2级事件）',
                    explanation:'系统的事件紧急程度中等或影响程度中等',
                    serviceIndicators:'1小时内响应',
                    remarks:'如:由于服务器性能下降导致部分用户访问响应变慢等'
                },
                {
                    claim:'三级事件（P3级事件）',
                    explanation:'系统的事件紧急程度低或影响程度小',
                    serviceIndicators:'6小时内响应',
                    remarks:'如:个别用户无法访问服务'
                },
                {
                    claim:'四级事件（P4级事件）',
                    explanation:'对客户系统无影响的事件',
                    serviceIndicators:'24小时内响应',
                    remarks:'客户服务请求,不影响当前服务运行'
                }] //备注

            }
        },
        beforeCreate: function() {
            previewVue = this
        },
        mounted(){
            //自适应不同屏幕尺寸
            const self=this;
            window.addEventListener("resize",function(){
                self.chartEventOverview.resize();
                self.chartAnnualMonthlyExpenses.resize();
                self.chartWarning.resize();
                self.totalEventsChart.resize();
            });
        },
        created(){
            this.$nextTick(function() {
                previewVue.eventOverviews();
                previewVue.annualMonthlyExpensess();
            });
        },
        methods:{
            /*************************************************************************/
            // 根据ID查询Report
            queryById:function(){
                this.$api.report.queryById("id",this.previewEditOldForm.id)
                .then(res => {
                    this.companyName=res.data.companyName;
                    this.year=res.data.year;
                    this.month=res.data.month;
                    // 月度账务分析原因
                    this.billAnalysis=res.data.billAnalysis;
                    // EC2优化建议
                    this.ec2OptimizeSuggestion=res.data.ec2OptimizeSuggestion;
                    // RDS优化建议
                    this.rdsOptimizeSuggestion=res.data.rdsOptimizeSuggestion;
                })
            },
            /*****************************重大事件********************************************/
            // 查询运维报告重大事件列表
            selectReportEventList:function(){
                this.$api.reportEvent.selectReportEventList({
                    "reportId": this.previewEditOldForm.id
                })
                .then(res => {
                    this.reportEventList=res.data;
                })
            },
            /******************表格*******************************************************/
            // EC2优化建议&RDS优化建议
            selectReportOptimizeListInstance:function(){
                this.$api.reportOptimize.selectReportOptimizeList({
                    "reportId": this.previewEditOldForm.id
                })
                .then(res => {
                    this.newEc2Suggest=[];
                    this.newRdsSuggest=[];
                    this.ec2Suggest = res.data;
                    for(var i=0;i<this.ec2Suggest.length;i++){
                        if(this.ec2Suggest[i].type==0){
                            this.newEc2Suggest.push(this.ec2Suggest[i]);
                        }else if(this.ec2Suggest[i].type==1){
                            this.newRdsSuggest.push(this.ec2Suggest[i]);
                        }
                    }

                })
            },
            // 降级前后花费对比
            selectReportOptimizeListComparison:function(){
                this.$api.reportOptimize.selectReportOptimizeList({
                    "reportId": this.previewEditOldForm.id
                })
                .then(res => {
                    this.saveMoney=0;
                    this.instanceRelegationCost = res.data;
                    for(var i=0;i<this.instanceRelegationCost.length;i++){
                        // 优化类型
                        if(this.instanceRelegationCost[i].optimizeType==0){
                            this.instanceRelegationCost[i].optimizeType='升级';
                        }else if(this.instanceRelegationCost[i].optimizeType==1){
                            this.instanceRelegationCost[i].optimizeType='降级';
                        }

                        // 可节省花费
                        if(this.instanceRelegationCost[i].saveCost!=undefined){
                            this.saveMoney+=this.instanceRelegationCost[i].saveCost;
                        }
                    }
                })
            },
            // 预留实例推荐花费对比
            listReportReservedInstances:function(){
                this.$api.reportReservedInstance.listReportReservedInstances({
                    "reportId" : this.previewEditOldForm.id,
                    "reportReservedInstanceType" : 0
                })
                .then(res => {
                    this.riCost = res.data;
                    for(var i=0;i<this.riCost.length;i++){
                        // 租赁类型
                        if(this.riCost[i].instanceTenancy==0){
                            this.riCost[i].instanceTenancy='default';
                        }else if(this.riCost[i].instanceTenancy==1){
                            this.riCost[i].instanceTenancy='dedicated';
                        }else if(this.riCost[i].instanceTenancy==2){
                            this.riCost[i].instanceTenancy='host';
                        }

                        // 如果是单账户表标题显示"账号ID、账号名称" 如果是账户组表标题显示"账户组名称"
                        if(this.riCost[i].accountGroupName){
                            this.isAccountGroupName=true;
                            this.costComparison=false;
                        }else{
                            this.isAccountGroupName=false;
                            this.costComparison=true;
                        }
                    }
                })
            },
            // RI匹配情况
            listProdEnvironmentReservedInstance:function(){
                this.$api.reportReservedInstance.listReportReservedInstances({
                    "reportId" : this.previewEditOldForm.id,
                    "reportReservedInstanceType" : 1
                })
                .then(res => {
                    this.console=0;
                    this.riMatching = res.data;
                    for(var i=0;i<this.riMatching.length;i++){
                        // 租赁类型
                        if(this.riMatching[i].instanceTenancy==0){
                            this.riMatching[i].instanceTenancy='default';
                        }else if(this.riMatching[i].instanceTenancy==1){
                            this.riMatching[i].instanceTenancy='dedicated';
                        }else if(this.riMatching[i].instanceTenancy==2){
                            this.riMatching[i].instanceTenancy='host';
                        }

                        // 总共购买数量
                        this.console+=this.riMatching[i].instanceCount;

                        // 如果是单账户表标题显示"账号ID、账号名称" 如果是账户组表标题显示"账户组名称"
                        if(this.riMatching[i].accountGroupName){
                            this.isReservedInstance=true;
                            this.reservedInstance=false;
                        }else{
                            this.isReservedInstance=false;
                            this.reservedInstance=true;
                        }
                    }
                })
            },
            // 本月运维事件
            selectOperationEvents:function(){
                this.$api.reportTicket.selectReportTicketList({
                    "reportId": this.previewEditOldForm.id
                })
                .then(res => {
                    this.newOperationEvents=[];
                    this.operationEvents = res.data;
                    for(var i=0;i<this.operationEvents.length;i++){
                        // 级别
                        if(this.operationEvents[i].priorityId==0){
                            this.operationEvents[i].priorityId='P1';
                        }else if(this.operationEvents[i].priorityId==1){
                            this.operationEvents[i].priorityId='P2';
                        }else if(this.operationEvents[i].priorityId==2){
                            this.operationEvents[i].priorityId='P3';
                        }else if(this.operationEvents[i].priorityId==3){
                            this.operationEvents[i].priorityId='P4';
                        }

                        if(this.operationEvents[i].type==0){
                            this.newOperationEvents.push(this.operationEvents[i]);
                        }
                    }
                })
            },
            // 上月待处理事件
            selectEventsPending:function(){
                this.$api.reportTicket.selectReportTicketList({
                    "reportId":this.previewEditOldForm.id
                })
                .then(res => {
                    this.newPendingEvents=[];
                    this.pendingEvents = res.data;
                    for(var i=0;i<this.pendingEvents.length;i++){
                        // 所属类型
                        if(this.pendingEvents[i].ticketCategory==0){
                            this.pendingEvents[i].ticketCategory='基础架构告警事件';
                        }else if(this.pendingEvents[i].ticketCategory==1){
                            this.pendingEvents[i].ticketCategory='安全告警事件';
                        }else if(this.pendingEvents[i].ticketCategory==2){
                            this.pendingEvents[i].ticketCategory='账单告警事件';
                        }else if(this.pendingEvents[i].ticketCategory==4){
                            this.pendingEvents[i].ticketCategory='公司贡献';
                        }else if(this.pendingEvents[i].ticketCategory==5){
                            this.pendingEvents[i].ticketCategory='变更请求';
                        }else if(this.pendingEvents[i].ticketCategory==6){
                            this.pendingEvents[i].ticketCategory='定时任务管理';
                        }else if(this.pendingEvents[i].ticketCategory==7){
                            this.pendingEvents[i].ticketCategory='服务申请';
                        }

                        if(this.pendingEvents[i].type==1){
                            this.newPendingEvents.push(this.pendingEvents[i]);
                        }
                    }
                })
            },

            /******************图表*******************************************************/
            init:function(){
                this.$nextTick(function() {
                    previewVue.eventOverviewLine();
                    previewVue.annualMonthlyExpensesLine();
                    previewVue.warningLine();
                    previewVue.totalEventsLine();
                });
            },
            /******************事件总览************************/
            eventOverviews:function(){
                if(this.previewEditOldForm.id==undefined){
                    return;
                }
                this.$api.reportTicket.selectPreviewByReportTicket({
                    "reportId": this.previewEditOldForm.id
                })
                .then(res => {
                    // 警报分析
                    this.reviews=res.data.reviews;
                    this.xaxisAlerts=res.data.xaxisAlert;
                    this.alertAmounts=res.data.alertAmounts;
                    // 事件总览
                    this.xaxisTicket=res.data.xaxisTicket;
                    this.p1Amounts=res.data.p1Amounts;
                    this.p2Amounts=res.data.p2Amounts;
                    this.p3Amounts=res.data.p3Amounts;
                    this.amount=res.data.amount;
                    this.compareMonth=res.data.compareMonth;
                    this.increasedReduction=res.data.increasedReduction;
                    this.cmAmount=res.data.cmAmount;
                    this.responseTimeAvg=Number(res.data.responseTimeAvg).toFixed(2);
                    this.solutionTimeAvg=Number(res.data.solutionTimeAvg).toFixed(2);
                    this.init();
                })
            },
            // 事件总览
            eventOverviewLine:function(){
                this.chartEventOverview=this.$echarts.init(document.getElementById("eventOverview"));
                this.chartEventOverview.setOption({
                    title: {
                        text: '事件总览',
                        x: 'center',
                        textStyle:{
                            fontSize:13//主题文字字体大小，默认为18px
                        }
                    },
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                            type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                        }
                    },
                    legend: {
                        bottom: 0,
                        data: ['P1', 'P2', 'P3']
                    },
                    grid: {
                        left: '3%',
                        right: '4%',
                        bottom: '9%',
                        containLabel: true
                    },
                    xAxis: [
                        {
                            type: 'category',
                            data: this.xaxisTicket
                        }
                    ],
                    yAxis: [
                        {
                            type: 'value'
                        }
                    ],
                    series: [
                        {
                            name: 'P1',
                            type: 'bar',
                            label: {
                                normal: {
                                    show: true,
                                    position: 'top'
                                }
                            },
                            data: this.p1Amounts
                        },

                        {
                            name: 'P2',
                            type: 'bar',
                            label: {
                                normal: {
                                    show: true,
                                    position: 'top'
                                }
                            },
                            data: this.p2Amounts
                        },
                        {
                            name: 'P3',
                            type: 'bar',
                            label: {
                                normal: {
                                    show: true,
                                    position: 'top'
                                }
                            },
                            data: this.p3Amounts
                        }
                    ]
                })
            },
            /******************警报分析************************/
            // 警报分析
            warningLine:function(){
                this.chartWarning=this.$echarts.init(document.getElementById("warning"));
                this.chartWarning.setOption({
                    title: {
                        text: '警报分析',
                        x: 'center',
                        textStyle:{
                            fontSize:13//主题文字字体大小，默认为18px
                        }
                    },
                    tooltip: {},
                    legend: {
                        bottom: 0,
                        data: ['报警']
                    },
                    grid: {
                        left: '2%',
                        right: '2%',
                        bottom: '9%',
                        containLabel: true,
                        y2: 140
                    },
                    xAxis: {
                        data: this.xaxisAlerts
                    },
                    yAxis: {
                        min: 0,
                        max: 20
                    },
                    series: [{
                        name: '报警',
                        type: 'bar',
                        barWidth: '40%',
                        label: {
                            normal: {
                                show: true,
                                position: 'top'
                            }
                        },
                        data: this.alertAmounts
                    }]
                })
            },
            /******************年度每月花费************************/
            annualMonthlyExpensess:function(){
                if(this.previewEditOldForm.id==undefined){
                    return;
                }
                this.$api.reportReservedInstance.getMonthlyBillingAnalysis({
                    "accountPrimaryKeyIds": this.previewEditOldForm.accountIdList,
                    "reportId" : this.previewEditOldForm.id,
                    "companyId" : this.previewEditOldForm.companyId,
                    "monthStr" : this.previewEditOldForm.reportDate
                })
                .then(res => {
                    // 相对月份
                    this.billRelativeMonthStr=res.data.billRelativeMonthStr;
                    // 花费上升下降
                    this.billCompareResult=res.data.billCompareResult;
                    if(this.billCompareResult==0){
                        this.billCompareResult='上升';
                    }else if(this.billCompareResult==1){
                        this.billCompareResult='下降';
                    }
                    // 上升下降比率
                    this.billCompareResultRatio=res.data.billCompareResultRatio;
                    // 年度每月花费
                    this.annualMonthlyExpenditure=res.data.annualMonthlyExpenditure;
                    this.xaxisData=res.data.xaxisData;

                    /**************************Top5服务花费*******************/
                    // 主要花费服务
                    this.mainFocusService=res.data.mainFocusService;
                    this.allServiceTotalCost=res.data.allServiceTotalCost;
                    this.serviceNameList=res.data.serviceNameList;
                    this.top5ServiceCosts=res.data.top5ServiceCosts;
                    this.init();
                })
            },
            // 年度每月花费
            annualMonthlyExpensesLine:function(){
                this.chartAnnualMonthlyExpenses=this.$echarts.init(document.getElementById("annualMonthlyExpenses"));
                this.chartAnnualMonthlyExpenses.setOption({
                    title: {
                        text: '年度每月花费',
                        x: 'center',
                        textStyle:{
                            fontSize:13//主题文字字体大小，默认为18px
                        }
                    },
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'cross',
                            label: {
                                backgroundColor: '#6a7985'
                            }
                        }
                    },
                    legend: {
                        bottom: 0,
                        data: ['月度花费']
                    },
                    toolbox: {
                        feature: {
                            saveAsImage: {}
                        }
                    },
                    grid: {
                        left: '2%',
                        right: '2%',
                        bottom: '9%',
                        containLabel: true,
                        y2: 140
                    },
                    xAxis: [
                        {
                            type: 'category',
                            boundaryGap: false,
                            data: this.xaxisData,
                            axisLabel: {
                                interval: 0,
                                rotate: 40
                            },
                        }
                    ],
                    yAxis: [
                        {
                            type: 'value',
                        }
                    ],
                    series: [

                        {
                            name: '月度花费',
                            type: 'line',
                            stack: '总量',
                            label: {
                                normal: {
                                    show: true,
                                    position: 'top'
                                }
                            },
                            areaStyle: { normal: {} },
                            data: this.annualMonthlyExpenditure
                        }
                    ]
                })
            },
            /******************Top5服务花费************************/
            // Top5服务花费
            totalEventsLine:function(){
                this.totalEventsChart=this.$echarts.init(document.getElementById("totalEvents"));
                this.totalEventsChart.setOption({
                    title: {
                        text: '￥'+this.allServiceTotalCost,
                        x: 'center',
                        y: 'center'
                    },
                    tooltip: {
                        trigger: 'item',
                        formatter: '{a} <br/>{b}: {c} ({d}%)',
                        confine: true
                    },
                    legend: {
                        orient: 'vertical',
                        left: 10,
                        data: this.serviceNameList
                    },
                    series: [
                        {
                            type: 'pie',
                            center: ['50%', '50%'],
                            radius: ['55%', '70%'],
                            avoidLabelOverlap: false,
                            label: {
                                show: true
                            },
                            emphasis: {
                                label: {
                                    show: true,
                                    fontSize: '12',
                                    fontWeight: 'bold'
                                }
                            },
                            labelLine: {
                                show: true
                            },
                            data:this.top5ServiceCosts
                        }
                    ]
                });
            }
        }
    }
</script>

<style scoped>
    #preview-main{
        width: 210mm;
        margin: 0 auto;
        padding: 10mm;
    }
    .report
    {
        width: 210mm;
        margin: auto;
    }
    /*封面*/
    .report-cover
    {
        width: 210mm;
    }
    .report-cover-bottom
    {
        width: 210mm;
        overflow: hidden;
        height: 301px;
    }
    .report-cover-bottom>img
    {
        width: 210mm;
        height: 268px;
    }
    .report-cover-main
    {
        width: 90%;
        height: 615px;
        margin: auto;
    }
    .report-cover-main>div:nth-child(1)
    {
        font-size: 175px;
        height: 208px;
    }
    .report-cover-main>div:nth-child(2)
    {
        font-size: 35px;
        height: 54px;
    }
    .report-cover-main>div:nth-child(3)
    {
        font-size: 24px;
        min-height: 58px;
    }
    .report-cover-main>div:nth-child(4)
    {
        font-size: 19px;
        height: 55px;
    }
    .report-cover-main>div:nth-child(5)
    {
        font-size: 14px;
    }

    /*目录*/
    .report-contents
    {
        width: 210mm;
        overflow: hidden;
    }
    .report-img-second
    {
        width: 26%;
        height: 93%;
        display: block;
        margin-top: -160px;
        margin-left: 67px;
    }
    .report-contents-right
    {
        width: 80%;
        margin: auto;
    }
    .report-contents-title
    {
        width: 210mm;
        margin-bottom: 36px;
        min-height: 114px;
    }
    .report-contents-title-left
    {
        float: left;
        width: 75px;
        height: 45px;
        text-align: center;
        font-size: 45px;
        margin-right: 31px;
    }
    .report-contents-title-right
    {
        float: left;
    }
    .report-contents-title-right>div:nth-child(1)
    {
        font-size: 20px;
    }
    .report-contents-title-right>div:nth-child(2)
    {
        font-size: 14px;
    }
    .report-contents-title-right>div:nth-child(3)
    {
        font-size: 13px;
        margin-left: 20px;
    }
    .report-contents-title-right>div:nth-child(4)
    {
        font-size: 14px;
    }
    .report-contents-bottom
    {
        width: 210mm;
        overflow: hidden;
        height: 301px;

    }
    .report-contents-bottom>img
    {
        width: 210mm;
        height: 268px;
    }
    #contents-second
    {
        margin-left: 0;
    }

    /*工作总结*/
    .summary
    {
        width: 210mm;
        min-height: 1046px;
    }
    .summary-bigTitle
    {
        font-size: 17px;
        margin-bottom: 10px;
    }
    .summary-secondTitle
    {
        font-size: 16px;
    }
    .summary-thirdTitle
    {
        font-size: 15px;
        font-weight: 600;
    }
    .summary-event
    {
        width: 210mm;
        height: 480px;
    }
    .summary-first
    {
        font-size: 14px;
        margin-bottom: 10px;
        margin-top: 10px;
    }
    .summary-second
    {
        font-size: 14px;
        margin-bottom: 10px;
    }
    .summary-third
    {
        font-size: 14px;
        margin-top: 10px;
    }
    .summary-time
    {
        border-radius: 5px;
        margin-top: 17px;
        width: 210mm;
        height: auto;
        border: 1px solid #e2e2e2;
        box-shadow: 0 2px 5px rgba(0,0,0,.1);
    }
    .summary-time-title
    {
        width: 210mm;
        height: 40px;
        line-height: 40px;
        padding-left: 9px;
        box-sizing: border-box;
        border-radius: 2px;
        font-size: 14px;
        font-weight: 600;
        border-bottom: 1px solid #eaeaea;
    }
    .summary-time>div:nth-child(2)
    {
        height: 300px;
        line-height: 264px;
        text-align: center;
        font-size: 60px;
    }

    /*1.2 月度账务分析*/
    .accounting
    {
        width: 210mm;
        min-height: 898px;
    }
    .accounting-first
    {
        font-size: 14px;
        margin-bottom: 10px;
    }
    .accounting-second
    {
        font-size: 14px;
        margin-bottom: 25px;
    }
    .accounting-third
    {
        font-size: 14px;
    }
    .accounting-secondTitle
    {
        font-size: 16px;
        margin-bottom: 10px;
        margin-top: 14px;
    }
    #annualMonthlyExpenses
    {
        width: 210mm;
        height: 480px;
        margin-bottom: 25px;
    }

    /*2 实例优化建议*/
    .example
    {
        width: 210mm;
        min-height: 814px;
    }
    .example-bigTitle
    {
        font-size: 17px;
        margin-bottom: 10px;
    }
    .example-EC2
    {
        width: 210mm;
        height: auto;
        margin-bottom: 25px;
    }
    .example-EC2-title
    {
        width: 210mm;
        height: 40px;
        text-align: center;
        line-height: 27px;
        font-size: 14px;
    }
    .example-suggestion
    {
        width: 210mm;
        height: auto;
        /* background-color: red; */
        border: 1px solid #eae3e3;
        border-radius: 5px;
        padding: 10px;
        margin-bottom: 20px;
    }
    .example-first
    {
        margin-bottom: 13px;
        font-size: 14px;
    }
    .report table
    {
        width: 210mm;
        height: auto;
        border-radius: 5px;
        border: 1px solid #eae8e8;
        box-shadow: 0 2px 5px rgba(0,0,0,.1);
    }

    /*其他优化建议*/
    .other
    {
        width: 210mm;
        min-height:100px;
    }
    .other-first
    {
        font-size: 14px;
        margin-bottom: 15px;
    }
    #warning
    {
        width: 210mm;
        height:480px;
    }
    /*运维工作*/
    .important
    {
        width: 210mm;
        min-height:100px;
    }
    .important-main
    {
        width: 210mm;
        height: auto;
        border: 1px solid #eae8e8;
        box-shadow: 0 2px 5px rgba(0,0,0,.1);
        margin-bottom: 10px;
    }
    .important-main-title
    {
        width: 210mm;
        height: 40px;
        line-height: 40px;
        font-size: 14px;
        box-sizing: border-box;
        padding-left: 9px;
        border-bottom: 1px solid #ccc;
        font-weight: 600;
    }
    .important-main-first
    {
        width: 97%;
        height: auto;
        border-bottom: 1px solid #ccc;
        font-size: 14px;
        padding: 10px;
    }
    .important-main-first>span:first-child
    {
        display: block;
        width: 210mm;
        font-weight: 600;
        height: 27px;
    }
    .important-main-second
    {
        width: 97%;
        height: auto;
        font-size: 14px;
        padding: 10px;
    }
    .important-main-second>span:first-child
    {
        display: block;
        width: 210mm;
        font-weight: 600;
        height: 27px;
    }
    .important-bigTitle
    {
        font-size: 17px;
        margin-bottom: 10px;
        overflow: hidden;
    }
    .important-secondTitle
    {
        font-size: 16px;
        margin-bottom: 10px;
    }
    .operationalEvent
    {
        width: 210mm;
        height: auto;
    }
    .operationalEvent-first
    {
        font-size: 14px;
        margin-bottom: 10px;
        margin-top: 10px;
    }
    /*重大事件*/
    .majorEvent
    {
        width: 210mm;
        min-height:100px;
        margin-top: 20px;
    }
    .majorEvent-bigTitle
    {
        font-size: 17px;
        margin-bottom: 10px;
        overflow: hidden;
    }
    .majorEvent-main{
        width: 210mm;
        border:1px solid #dfe1e5;
        margin-bottom: 20px;
        box-shadow: 0 2px 5px rgba(0,0,0,.1);
    }
    .majorEvent-title{
        height: 46px;
        border-bottom: 1px solid #dfe1e5;
        padding: 10px;
        font-size: 13px;
        font-weight: 600;
    }
    .majorEvent-second{
        min-height: 46px;
        border-bottom: 1px solid #dfe1e5;
        padding: 10px;
        font-size: 13px;
    }
    .majorEvent-second>div:nth-child(1){
        font-weight: 600;
        font-size: 13px;
    }
    /*目录*/
    #secondColumn
    {
        font-size:14px;
        margin-left: 0px;
    }
    #thirdColumn>div
    {
        font-size: 13px;
        margin-left: 20px;
    }
    #table-first
    {
        width: 100%;
        height: auto;
        border-top: 1px solid #dfe1e5;
        border-left: 1px solid #dfe1e5;
        border-right: 1px solid #dfe1e5;
    }
    #table-first th
    {
        height: 40px;
        white-space: nowrap;
        overflow: hidden;
        font-size: 12px;
        background-color: #f8f8f9;
        border-bottom: 1px solid #dfe1e5;
        text-align: left;
        padding-left: 18px;

    }
    #table-first td
    {
        min-width: 0;
        height: 48px;
        text-align: left;
        text-overflow: ellipsis;
        vertical-align: middle;
        border-bottom: 1px solid #e8eaec;
        font-size: 12px;
        padding-left: 18px;
        padding-right: 18px;
        overflow: hidden;
        white-space: normal;
        word-break: break-all;
        box-sizing: border-box;
    }
    #table-second
    {
        width: 100%;
        height: auto;
        border-top: 1px solid #dfe1e5;
        border-left: 1px solid #dfe1e5;
        border-right: 1px solid #dfe1e5;
    }
    #table-second th
    {
        height: 40px;
        white-space: nowrap;
        overflow: hidden;
        font-size: 12px;
        background-color: #f8f8f9;
        border-bottom: 1px solid #dfe1e5;
        text-align: left;
        padding-left: 18px;

    }
    #table-second td
    {
        min-width: 0;
        height: 48px;
        text-align: left;
        text-overflow: ellipsis;
        vertical-align: middle;
        border-bottom: 1px solid #e8eaec;
        font-size: 12px;
        padding-left: 18px;
        padding-right: 18px;
        overflow: hidden;
        white-space: normal;
        word-break: break-all;
        box-sizing: border-box;
    }
    #table-third
    {
        width: 100%;
        height: auto;
        border-top: 1px solid #dfe1e5;
        border-left: 1px solid #dfe1e5;
        border-right: 1px solid #dfe1e5;
    }
    #table-third th
    {
        height: 40px;
        white-space: nowrap;
        overflow: hidden;
        font-size: 12px;
        background-color: #f8f8f9;
        border-bottom: 1px solid #dfe1e5;
        text-align: left;
        padding-left: 18px;

    }
    #table-third td
    {
        min-width: 0;
        height: 48px;
        text-align: left;
        text-overflow: ellipsis;
        vertical-align: middle;
        border-bottom: 1px solid #e8eaec;
        font-size: 12px;
        padding-left: 18px;
        padding-right: 18px;
        overflow: hidden;
        white-space: normal;
        word-break: break-all;
        box-sizing: border-box;
    }
    #table-fourth
    {
        width: 100%;
        height: auto;
        border-top: 1px solid #dfe1e5;
        border-left: 1px solid #dfe1e5;
        border-right: 1px solid #dfe1e5;
    }
    #table-fourth th
    {
        height: 40px;
        white-space: normal;
        overflow: hidden;
        font-size: 12px;
        background-color: #f8f8f9;
        border-bottom: 1px solid #dfe1e5;
        text-align: left;
        padding-left: 18px;

    }
    #table-fourth td
    {
        min-width: 0;
        height: 48px;
        text-align: left;
        text-overflow: ellipsis;
        vertical-align: middle;
        border-bottom: 1px solid #e8eaec;
        font-size: 12px;
        padding-left: 18px;
        padding-right: 18px;
        overflow: hidden;
        white-space: normal;
        word-break: break-all;
        box-sizing: border-box;
    }
    #table-fifth
    {
        width: 100%;
        height: auto;
        border-top: 1px solid #dfe1e5;
        border-left: 1px solid #dfe1e5;
        border-right: 1px solid #dfe1e5;
    }
    #table-fifth th
    {
        height: 40px;
        white-space: nowrap;
        overflow: hidden;
        font-size: 12px;
        background-color: #f8f8f9;
        border-bottom: 1px solid #dfe1e5;
        text-align: left;
        padding-left: 18px;

    }
    #table-fifth td
    {
        min-width: 0;
        height: 48px;
        text-align: left;
        text-overflow: ellipsis;
        vertical-align: middle;
        border-bottom: 1px solid #e8eaec;
        font-size: 12px;
        padding-left: 18px;
        padding-right: 18px;
        overflow: hidden;
        white-space: normal;
        word-break: break-all;
        box-sizing: border-box;
    }
    #table-sixth
    {
        width: 100%;
        height: auto;
        border-top: 1px solid #dfe1e5;
        border-left: 1px solid #dfe1e5;
        border-right: 1px solid #dfe1e5;
    }
    #table-sixth th
    {
        height: 40px;
        white-space: nowrap;
        overflow: hidden;
        font-size: 12px;
        background-color: #f8f8f9;
        border-bottom: 1px solid #dfe1e5;
        text-align: left;
        padding-left: 18px;

    }
    #table-sixth td
    {
        min-width: 0;
        height: 48px;
        text-align: left;
        text-overflow: ellipsis;
        vertical-align: middle;
        border-bottom: 1px solid #e8eaec;
        font-size: 12px;
        padding-left: 18px;
        padding-right: 18px;
        overflow: hidden;
        white-space: normal;
        word-break: break-all;
        box-sizing: border-box;
    }
    #table-seventh
    {
        width: 100%;
        height: auto;
        border-top: 1px solid #dfe1e5;
        border-left: 1px solid #dfe1e5;
        border-right: 1px solid #dfe1e5;
    }
    #table-seventh th
    {
        height: 40px;
        white-space: nowrap;
        overflow: hidden;
        font-size: 12px;
        background-color: #f8f8f9;
        border-bottom: 1px solid #dfe1e5;
        text-align: left;
        padding-left: 18px;

    }
    #table-seventh td
    {
        min-width: 0;
        height: 48px;
        text-align: left;
        text-overflow: ellipsis;
        vertical-align: middle;
        border-bottom: 1px solid #e8eaec;
        font-size: 12px;
        padding-left: 18px;
        padding-right: 18px;
        overflow: hidden;
        white-space: normal;
        word-break: break-all;
        box-sizing: border-box;
    }
    #table-eighth
    {
        width: 100%;
        height: auto;
        border-top: 1px solid #dfe1e5;
        border-left: 1px solid #dfe1e5;
        border-right: 1px solid #dfe1e5;
    }
    #table-eighth th
    {
        height: 40px;
        white-space: nowrap;
        overflow: hidden;
        font-size: 12px;
        background-color: #f8f8f9;
        border-bottom: 1px solid #dfe1e5;
        text-align: left;
        padding-left: 18px;

    }
    #table-eighth td
    {
        min-width: 0;
        height: 48px;
        text-align: left;
        text-overflow: ellipsis;
        vertical-align: middle;
        border-bottom: 1px solid #e8eaec;
        font-size: 12px;
        padding-left: 18px;
        padding-right: 18px;
        overflow: hidden;
        white-space: normal;
        word-break: break-all;
        box-sizing: border-box;
    }
</style>



// WEBPACK FOOTER //
// src/components/configuration/operation_kpi_configuration_management/operation_report/Preview.vue